export const SLOTS = {
  input: "input",
};

export const CSS = {
  segmentedControlItemIcon: "segmented-control-item-icon",
};
